import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import template from '@/../templates/device-list-controls.hbs';

    var control_defaults = {
        show_restart_action: true,
        show_move_action: true,
        show_unassign_action: false
    };

    var view = Marionette.View.extend({
        template: Handlebars.compile(template),
        ui: {
            'restart': '.restart',
            'move': '.move',
            'unassign': '.unassign',
            'download': '.download',
            'prev': '.prev',
            'next': '.next',
        },
        triggers: {
            'click @ui.restart': 'restart',
            'click @ui.move': 'move',
            'click @ui.unassign': 'unassign',
            'click @ui.download': 'download',
        },
        templateContext: function(){
            return _.defaults({
                show_restart_action: this.getOption('show_restart_action'),
                show_move_action: this.getOption('show_move_action'),
                show_unassign_action: this.getOption('show_unassign_action')
            }, control_defaults);

        },
        toggle_actions: function(count){
            if ( count > 0 ){
                this.ui.unassign.attr('disabled', false);
                this.ui.restart.attr('disabled', false);
            } else {
                this.ui.unassign.attr('disabled', true);
                this.ui.restart.attr('disabled', true);
            }
        },
        toggle_action: function(action){
            this.ui[action].attr('disabled', !this.ui[action].attr('disabled'));
        },
        disable_actions: function(actions){
            for (var action in arguments) {
                this.ui[[arguments[action]]].attr('disabled', true);
            }
        },
        enable_actions: function (actions){
            for (var action in arguments) {
                this.ui[arguments[action]].attr('disabled', false);
            }
        },
    });
    export default view;

